export default __webpack_public_path__ + "static/media/9.fa4ea49d.jpg";